// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright blockquote undo redo removeformat subscript superscript codesample hr', 'bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor']

export default toolbar